<mat-card>
    <div class="border-left card px-3">
        <div class="my-2 p-0">
            <button type="button" class="btn btn-outline-secondary btn-sm border-0"
                    [matMenuTriggerFor]="cardHeaderMenu">
                Graphique<i class="fa-solid fa-angle-down ms-2"></i>
            </button>
            <!--<button type="button" class="btn btn-outline-secondary btn-sm border-0"
                    [matMenuTriggerFor]="durationMenu">
                Dureé<i class="fa-solid fa-angle-down ms-2"></i>
            </button>-->
        </div>
        <div class="charts mb-25 mx-3 row">

            <div class="line border col-lg-8" [chart]="lineChart">

            </div>
            <div class="pie border col-lg-4" [chart]="pieChart">

            </div>
  
        </div>
    </div>
</mat-card>

<mat-menu #cardHeaderMenu="matMenu" class="card-header-menu" xPosition="after">
    @for (type of chartTypess; track $index) {
        <button mat-menu-item (click)="handleChartType(type)">
            {{ type.toUpperCase() }}
        </button>
    }
</mat-menu>

<mat-menu #durationMenu="matMenu" class="card-header-menu" xPosition="after">


</mat-menu>
